import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import BrandingPanel from './components/BrandingPanel';
import MobileHeader from './components/MobileHeader';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in
    const userRole = localStorage.getItem('userRole');
    const rememberMe = localStorage.getItem('rememberMe') === 'true';
    
    if (userRole && rememberMe) {
      // Redirect to appropriate dashboard based on role
      switch (userRole) {
        case 'admin': navigate('/admin-dashboard');
          break;
        case 'technician': navigate('/technician-mobile');
          break;
        case 'client': navigate('/client-portal');
          break;
        default:
          navigate('/admin-dashboard');
      }
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background">
      {/* Mobile Header */}
      <MobileHeader />
      {/* Main Content */}
      <div className="flex min-h-screen lg:min-h-0">
        {/* Login Form Section */}
        <div className="flex-1 flex items-center justify-center p-6 lg:p-8">
          <div className="w-full max-w-md">
            <LoginForm />
            
            {/* Mobile Footer */}
            <div className="lg:hidden mt-8 text-center">
              <div className="flex items-center justify-center space-x-6 text-xs text-muted-foreground">
                <span className="flex items-center">
                  <span className="w-2 h-2 bg-success rounded-full mr-1"></span>
                  Sistema Online
                </span>
                <span>© {new Date()?.getFullYear()} ConsultFlow</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Branding Panel - Desktop Only */}
        <BrandingPanel />
      </div>
    </div>
  );
};

export default Login;